import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt, FaBoxOpen, FaRegClock, FaMoneyBillWave, FaShippingFast } from "react-icons/fa";

const ViewOrder = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await fetch(`https://api.irfanelectricals.com/api/order/${orderId}`);
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        if (data.success && data.order) {
          setOrder(data.order);
        } else {
          throw new Error("Failed to fetch order details.");
        }
      } catch (error) {
        console.error("Error fetching order:", error.message);
        alert(error.message || "Failed to fetch order details.");
      } finally {
        setLoading(false);
      }
    };

    if (orderId) {
      fetchOrder();
    }
  }, [orderId]);

  if (loading) return <p>Loading...</p>;
  if (!order) return <p>Order not found</p>;

  return (
    <div className="container mt-5">
      <h2>📦 Order Details</h2>

      <div className="card p-4 mb-4">
        <div className="row">
          <div className="col-md-6">
            <h4><FaUser className="text-primary" /> Customer Details</h4>
            <p><strong>Name:</strong> {order.first_name} {order.last_name}</p>
            <p><FaEnvelope className="text-secondary" /> <strong>Email:</strong> {order.email}</p>
            <p><FaPhone className="text-secondary" /> <strong>Phone:</strong> {order.phone}</p>
            <p><FaMapMarkerAlt className="text-danger" /> <strong>Address:</strong> {order.address_line1}, {order.state}, {order.country}</p>
          </div>
          <div className="col-md-6">
            <h4><FaBoxOpen className="text-warning" /> Order Summary</h4>
            <p><FaRegClock className="text-info" /> <strong>Order Date:</strong> {new Date(order.created_at).toLocaleDateString()}</p>
            <p><FaMoneyBillWave className="text-success" /> <strong>Payment:</strong> {order.payment_method} ({order.payment_status})</p>
            <p><FaShippingFast className="text-primary" /> <strong>Status:</strong>
              <span className={`badge ms-2 ${order.status === 'Completed' ? 'bg-success' : order.status === 'Pending' ? 'bg-warning' : 'bg-secondary'}`}>
                {order.status}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div className="card p-4">
        <h4>🛒 Ordered Products</h4>
        <table className="table mt-3">
          <thead className="table-dark">
            <tr>
              <th>Product</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Subtotal</th>
            </tr>
          </thead>
          <tbody>
            {order.items.map((item, index) => (
              <tr key={index}>
                <td>{item.product_name}</td>
                <td>${item.price.toFixed(2)}</td>
                <td>{item.quantity}</td>
                <td>${(item.price * item.quantity).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Total Amount */}
        <h4 className="mt-4 text-end"><strong>Total: ${order.total_price.toFixed(2)}</strong></h4>

        {/* New Line About LC at Sight */}
        <p className="mt-3 text-danger fw-bold text-center">
          If You Have Placed Order Through LC at Sight  
        </p>
        <p className="mt-3 text-danger fw-bold text-center">
          You will need to mail an <u>Irrevocable LC at Sight</u> from an 1st class International Bank. on below mail 
        </p>
        <p className="mt-3 text-danger fw-bold text-center">
          orders@irfanelectricals.com
        </p>
      </div>

      <div className="mt-4">
        <Link to="/profile" className="btn btn-secondary">⬅ Back</Link>
      </div>
    </div>
  );
};

export default ViewOrder;
